module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-sm-offset-3"
  }, [_c('div', {
    staticClass: "card-box"
  }, [_c('h4', {
    staticClass: "header-title m-t-0 m-b-30"
  }, [_vm._v("Notifications")]), _vm._v(" "), _c('div', {
    staticClass: "row m-t-20"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 m-t-10"
  }, [_c('el-switch', {
    staticClass: "pull-right",
    attrs: {
      "disabled": !_vm.user.meta.deviceId,
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.notifications_desktop),
      callback: function($$v) {
        _vm.notifications_desktop = $$v
      },
      expression: "notifications_desktop"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(!_vm.user.meta.deviceId) ? _c('div', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "clear": "both",
      "text-align": "center"
    }
  }, [_vm._v("\n            Vous devez autoriser votre poste à recevoir des notifications bureau.\n          ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row m-t-20"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 m-t-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.preferences.reminders.notifications), function(notification, index) {
    return _c('div', {
      staticClass: "col-md-12",
      attrs: {
        "index": index
      }
    }, [_c('el-slider', {
      attrs: {
        "step": 5,
        "min": 0,
        "max": 60,
        "format-tooltip": _vm.sliderFormatMinutes
      },
      on: {
        "change": _vm.emptyRemindersNotifications
      },
      model: {
        value: (_vm.preferences.reminders.notifications[index]),
        callback: function($$v) {
          _vm.$set(_vm.preferences.reminders.notifications, index, $$v)
        },
        expression: "preferences.reminders.notifications[index]"
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('el-button', {
    staticClass: "pull-right",
    attrs: {
      "type": "success",
      "plain": true,
      "icon": "plus",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.preferences.reminders.notifications.push(0)
      }
    }
  })], 1)], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "card-box"
  }, [_c('h4', {
    staticClass: "header-title m-t-0"
  }, [_vm._v("Affichage")]), _vm._v(" "), _c('el-tabs', {
    model: {
      value: (_vm.tabs.active),
      callback: function($$v) {
        _vm.$set(_vm.tabs, "active", $$v)
      },
      expression: "tabs.active"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Rappels",
      "name": "reminders"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row m-t-20"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('h6', {
    staticClass: "m-0"
  }, [_vm._v("Rappels passés affichés")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_c('small', [_vm._v("Etendre l'affichage des rappels du jour et passés à plus de X jours.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 m-t-10"
  }, [_c('el-slider', {
    attrs: {
      "min": 0,
      "max": 180,
      "format-tooltip": _vm.sliderFormatDays
    },
    model: {
      value: (_vm.preferences.reminders.show_since_days),
      callback: function($$v) {
        _vm.$set(_vm.preferences.reminders, "show_since_days", $$v)
      },
      expression: "preferences.reminders.show_since_days"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row m-t-20"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('h6', {
    staticClass: "m-0"
  }, [_vm._v("Calendrier des RDV")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_c('small', [_vm._v("Changer le format d'affichage des rendez-vous.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 m-t-10"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.preferences.reminders.meeting_display_mode),
      callback: function($$v) {
        _vm.$set(_vm.preferences.reminders, "meeting_display_mode", $$v)
      },
      expression: "preferences.reminders.meeting_display_mode"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Par mois",
      "value": "monthly"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Par semaine",
      "value": "weekly"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "En liste",
      "value": "list"
    }
  })], 1)], 1)])])])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Liste de tâches",
      "name": "task_lists"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row m-t-20"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('h6', {
    staticClass: "m-0"
  }, [_vm._v("Mode d'intégration")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_c('small', [_vm._v("Choix de l'ajustement du corps l'interface.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 m-t-10"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.preferences.task_lists.display_mode),
      callback: function($$v) {
        _vm.$set(_vm.preferences.task_lists, "display_mode", $$v)
      },
      expression: "preferences.task_lists.display_mode"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Par dessus",
      "value": "floating"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Intégré",
      "value": "into"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row m-t-20"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('h6', {
    staticClass: "m-0"
  }, [_vm._v("Toujours ouvert")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_c('small', [_vm._v("Bloquer le panneau à droite et le laisser ouvert.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 m-t-10"
  }, [_c('el-switch', {
    staticClass: "pull-right",
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.preferences.task_lists.always_displayed),
      callback: function($$v) {
        _vm.$set(_vm.preferences.task_lists, "always_displayed", $$v)
      },
      expression: "preferences.task_lists.always_displayed"
    }
  })], 1)])])])])], 1)], 1), _vm._v(" "), _c('el-button', {
    staticClass: "waves-effect waves-light pull-right",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n      Enregistrer\n    ")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-8"
  }, [_c('h6', {
    staticClass: "m-0"
  }, [_vm._v("Notification Bureau")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_c('small', [_vm._v("Recevoir une notification sur le bureau au lieu d'un popup dans l'interface.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-8"
  }, [_c('h6', {
    staticClass: "m-0"
  }, [_vm._v("Pré-rappel de rendez-vous")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_c('small', [_vm._v("Recevoir des pré-notifications avant l'heure des rendez-vous.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5744c4a5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents/Main/Preferences.vue
// module id = 693
// module chunks = 1